var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8568,14.06547l-2.09506-2.052a.57986.57986,0,0,0-.808,0l-6.2869,6.15767a.5728.5728,0,0,0-.06669.07835.55023.55023,0,0,0-.08151.17339l-.83519,2.86305a.56558.56558,0,0,0,.7064.69181l2.92309-.818.01-.00278A.5743.5743,0,0,0,15.57,21.0146l6.28684-6.15767A.55159.55159,0,0,0,21.8568,14.06547Zm-8.79206,6.55934.2887-.98971.72177.70695Zm2.10116-.7974-1.287-1.26054,3.80277-3.72465,1.287,1.2606Zm4.61082-4.516-1.287-1.26054.868-.85016,1.287,1.26054Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3852,17.334a.56563.56563,0,0,0-.5714-.55963H3.16688V8.86483H18.78463v1.49236a.57152.57152,0,0,0,1.1428,0v-6.156a.56564.56564,0,0,0-.5714-.55964H16.57532V2.55961A.5656.5656,0,0,0,16.00392,2h-2.514a.56556.56556,0,0,0-.5714.55963V3.64154H9.03309V2.55961A.5656.5656,0,0,0,8.46169,2h-2.514a.56556.56556,0,0,0-.5714.55963V3.64154H2.59554a.5656.5656,0,0,0-.5714.55964V17.334a.5656.5656,0,0,0,.5714.55964H11.8138A.56564.56564,0,0,0,12.3852,17.334Zm1.676-14.21476h1.37135V5.28317H14.06122Zm-7.54223,0H7.89034V5.28317H6.519ZM5.37625,4.76082v1.082a.56559.56559,0,0,0,.5714.55963h2.514a.56563.56563,0,0,0,.5714-.55963v-1.082h3.88539v1.082a.56559.56559,0,0,0,.5714.55963h2.514a.56563.56563,0,0,0,.5714-.55963v-1.082h2.20931V7.74555H3.16688V4.76082Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.4d9ee46c5f376be8e805bbe265a7be5a.svg";
export { ForwardRef as ReactComponent };